module.exports = __webpack_public_path__ + "static/flags/GE-307cae97e9ea7eb1c46767327a46e2b0.gif";